<script>
  import Siema from "siema";
  import { onMount } from "svelte";

  let slider, prev, next, radioSlider;
  let select = 0;

  let data = [{ val: 1 }, { val: 2 }, { val: 3 }, { val: 4 }, { val: 5 }]; //end array data

  onMount(() => {
    slider = new Siema({
      selector: ".siema",
      duration: 200,
      easing: "ease-in-out",
      perPage: {
        800: 1, // 2 items for viewport wider than 800px
        1240: 1, // 3 items for viewport wider than 1240px
      },
      startIndex: 0,
      draggable: true,
      multipleDrag: true,
      threshold: 20,
      loop: true,
      rtl: false,
      onInit: () => {},
      onChange: () => {},
    }); //end Siema constructor

    prev = () => {
      slider.prev();
      if (select > 0) {
        select--;
      }
    };

    next = () => {
      slider.next();
      if (select >= 0) {
        select++;
      }
    };
    setInterval(() => next(), 5000)
  }); //end onMount

</script>

<div>
    <div class="siema">
        <div class="slider">
          <img src="./images/lernlive-1.png" alt="">
        </div>
        <div class="slider">
          <img src="./images/lernlive-2.png" alt="">
        </div>
    </div>
</div>

<style>
  .slider img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
</style>
